import React, { useMemo } from "react";
import { Divider, Grid, Typography } from "@mui/material";
import { FormProvider } from "react-hook-form";
import { BtnBack, BtnEdit, BtnPrint, BtnSave } from "components/Button/ButtonAll";
import TableSold from "../components/Sold/TableSold";
import TableCompareTicket from "../components/Sold/TableCompareTicket";
import TableMoney from "../components/Sold/TableMoney";
import TableReturnTicket from "../components/Sold/TableReturnTicket";
import { TextBoxItem } from "components/Input/TextBox";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import { SelectItem } from "components/Input/Select/SelectItem";
import { ProviderSoldTicket } from "../TicketSold/TicketSoldForm";
import ApproveCheckTicket from "../components/ApproveCheckTicket";
import { useCommitteeTicketForm } from "../../hooks/useCommitteeTicket";
import { Extension, ParseHtml } from "utilities/utilities";
import UploadFileItem from "components/Input/UploadFile";
import { RadioListItem } from "components/Input/Radio";


export const CommitteeTicketForm = () => {
    const {
        isPermission,
        statusID,
        isCommitteeMuseum,
        isView,
        form,
        gotoBack,
        handleSubmitForm,
        objMuseum,
        option,
        defaultValues,
        arrAttachmentList,
        setArrAttachmentList,
        onClearAttachFile,
        ExportPDF,
        lstTotalTicketSell,
        setLstTotalTicketSell,
        OnEditCommitTicketSold
    } = useCommitteeTicketForm();

    const objProvider = React.useMemo(() => (
        {
            isView,
            form,
            objMuseum,
            defaultValues,
            option,
            arrAttachmentList,
            setArrAttachmentList,
            onClearAttachFile,
            lstTotalTicketSell,
            setLstTotalTicketSell
        }
    ), [isView, form, objMuseum, defaultValues, option, arrAttachmentList, setArrAttachmentList, onClearAttachFile, lstTotalTicketSell, setLstTotalTicketSell]);

    const sSeller = useMemo(() => {
        let sSeller = "";
        if (defaultValues.arrSeller && option.lstSeller) {
            let newArrSeller = option.lstSeller.filter(item => defaultValues.arrSeller.includes(item.value));
            if (newArrSeller.length > 0) {
                let arrNameSeller = newArrSeller.map(item => { return ("- " + item.label) });
                sSeller = arrNameSeller.join("<br/>")
            }
        }
        return sSeller;
    }, [option.lstSeller, defaultValues.arrSeller])

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <ProviderSoldTicket.Provider
                    value={objProvider}
                >
                    <FormProvider {...form}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={3}>
                                <DatePickerItem
                                    name={"dSoldTicket"}
                                    id={"dSoldTicket"}
                                    label={`วันที่จำหน่าย`}
                                    fullWidth={true}
                                    required={false}
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} md={9}>
                                <TextBoxItem
                                    name={"sMuseum"}
                                    id={"sMuseum"}
                                    label={"พิพิธภัณฑ์"}
                                    maxLength={250}
                                    type={"text"}
                                    required={false}
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography className="font-weight-500">ผู้จำหน่าย</Typography>
                                {ParseHtml(sSeller)}
                            </Grid>
                            <Grid item xs={12}>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider textAlign="left" className="font-weight-500">รายการจำหน่าย</Divider>
                            </Grid>
                            <Grid item xs={12}>
                                <TableSold />
                            </Grid>
                            <Grid item xs={12}>
                                <TableMoney />
                            </Grid>
                            <Grid item xs={12}>
                                <Divider textAlign="left" className="font-weight-500">รายการคืน</Divider>
                            </Grid>
                            <Grid item xs={12}>
                                <TableReturnTicket />
                            </Grid>
                            <Grid item xs={12}>
                                <Divider textAlign="left" className="font-weight-500">เปรียบเทียบรายการเบิก</Divider>
                            </Grid>
                            <Grid item xs={12}>
                                <TableCompareTicket />
                            </Grid>
                            <Grid item xs={12}>
                                <Divider textAlign="left" className="font-weight-500">เจ้าหน้าที่ผู้ตรวจสอบ</Divider>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <SelectItem
                                    id={"nEmpFund"}
                                    name={"nEmpFund"}
                                    label={`กรรมการตรวจสอบการรับจ่ายเงิน`}
                                    required={true}
                                    options={option.lstEmpFund}
                                    disabled={[2, 5].includes(statusID) || !isCommitteeMuseum}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <SelectItem
                                    id={"nEmpMoney"}
                                    name={"nEmpMoney"}
                                    label={`การเงินและบัญชี`}
                                    required={true}
                                    options={option.lstEmpMoney}
                                    disabled={[2, 5].includes(statusID) || !isCommitteeMuseum}
                                />
                            </Grid>
                            
                            {
                                statusID === 1 && isCommitteeMuseum ?
                                    <Grid item xs={12} >
                                        <ApproveCheckTicket isCommittee isPermission={isPermission}/>
                                    </Grid>
                                    :
                                    null
                            }
                            {
                                [2, 3, 4, 5].includes(statusID) ?
                                    <>
                                        <Grid item xs={12}>
                                            <Divider textAlign="left" className="font-weight-500">ผลการตรวจสอบ</Divider>
                                        </Grid>
                                        <Grid item xs={12} >
                                            <RadioListItem
                                                id={"sApprove"}
                                                name={"sApprove"}
                                                required={true}
                                                label='ผลการตรวจสอบ'
                                                IsNotShowLabel
                                                disabled
                                                row
                                                options={[
                                                    { value: "A", label: "ผ่าน" },
                                                    { value: "R", label: "ไม่ผ่าน" },
                                                ]}
                                            />
                                        </Grid>
                                        <Grid item xs={12} >
                                            <UploadFileItem
                                                id="upFile"
                                                name={"upFile"}
                                                key={"upFile"}
                                                arrFile={arrAttachmentList}
                                                setarrFile={setArrAttachmentList}
                                                IsFolder={false}
                                                IsMultiple={false}
                                                Extension={Extension.FileTicket}
                                                nLimitFile={30}
                                                sLimitFile={"MB"}
                                                onClearFile={onClearAttachFile}
                                                modeDisplay={"list"}
                                                sFolderTemp={"SoldTicket"}
                                                sPositionText={"right"}
                                                required={false}
                                                disabled
                                                IsHiddenUploadBox
                                            />
                                        </Grid>
                                    </>
                                    :
                                    null
                            }
                        </Grid>
                    </FormProvider>
                </ProviderSoldTicket.Provider>
            </Grid>
            <Grid item xs={12}>
                <Grid
                    container
                    spacing={2}
                    justifyContent={"space-between"}
                    alignItems={"start"}
                >
                    <Grid item>
                        <BtnBack id={"btnback-ticket"} onClick={() => gotoBack()} />
                    </Grid>
                    <Grid item>
              
                        {statusID === 2 && isCommitteeMuseum &&
                            <BtnEdit
                                id={"btnEdit-ticketsold"}
                                txt="แก้ไขข้อมูล"
                                onClick={OnEditCommitTicketSold}
                            />
                        }
                        {
                            statusID === 1 && isCommitteeMuseum ? 
                                <Grid
                                    container
                                    spacing={2}
                                    justifyContent={"end"}
                                    alignItems={"start"}
                                >
                                    <Grid item>
                                        <BtnPrint
                                            id={"btnprint-ticket"}
                                            txt="พิมพ์เอกสารเพื่อลงนาม"
                                            onClick={ExportPDF}
                                            />
                                    </Grid>
                                    <Grid item>
                                        <BtnSave
                                            id={"btnsave-ticket"}
                                            onClick={form.handleSubmit(() => handleSubmitForm())}
                                        />
                                    </Grid>
                                </Grid>
                                :
                                null
                        }
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
